export default "__VITE_ASSET__6jAT9dPS__"